export default "__VITE_ASSET__D9SA4wd2__"